import produce from 'immer';
import { SET_CRM_OBJECTS_TO_EDIT, UPDATE_CRM_OBJECT_PROPERTY, FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED, CLEAR_MODIFIED_PATHS_WAITING_TO_SAVE, SET_MODIFIED_PATHS_WAITING_TO_SAVE } from 'ContentEditorUI/redux/actions/actionTypes';
import setIn from 'hs-lodash/set';
export const READ_ONLY = 'READ_ONLY';
export const initialState = {
  crmObjectByKey: {},
  fieldSchema: {},
  modifiedPathsWaitingToSave: []
};
export const crmObjectEditingReducer = (state = initialState, {
  type,
  response,
  payload
}) => produce(state, draft => {
  switch (type) {
    case SET_CRM_OBJECTS_TO_EDIT:
      draft.crmObjectByKey = Object.assign({}, draft.crmObjectByKey, response);
      return draft;
    case UPDATE_CRM_OBJECT_PROPERTY:
      {
        draft.crmObjectByKey = setIn(draft.crmObjectByKey, [...payload.path, 'value'], payload.value);
        if (payload.path.length > 0) {
          const modifiedPath = payload.path.join('.');
          const fullPath = `crm.${modifiedPath}`;
          if (!draft.modifiedPathsWaitingToSave.includes(fullPath)) {
            draft.modifiedPathsWaitingToSave.push(fullPath);
          }

          // If the path has an array index, and the crm object by key is an array, lets add a wild card path as well
          if (!isNaN(payload.path[1]) && Array.isArray(draft.crmObjectByKey[payload.path[0]])) {
            const wildcardPath = `crm.${payload.path[0]}.*.${payload.path.slice(2).join('.')}`;
            if (!draft.modifiedPathsWaitingToSave.includes(wildcardPath)) {
              draft.modifiedPathsWaitingToSave.push(wildcardPath);
            }
          }
        }
        return draft;
      }
    case FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED:
      if (payload && payload.fieldSchema) {
        draft.fieldSchema = Object.assign({}, draft.fieldSchema, payload.fieldSchema);
      }
      return draft;
    case SET_MODIFIED_PATHS_WAITING_TO_SAVE:
      draft.modifiedPathsWaitingToSave = payload.modifiedPathsWaitingToSave;
      return draft;
    case CLEAR_MODIFIED_PATHS_WAITING_TO_SAVE:
      draft.modifiedPathsWaitingToSave = [];
      return draft;
    default:
      return draft;
  }
});
export default crmObjectEditingReducer;